<h2 mat-dialog-title id="edit-user-title">Edit User</h2>
<mat-dialog-content>
    <form
        id="edit-user-form"
        [formGroup]="editUserForm"
        (ngSubmit)="editUser()"
    >
        <div id="edit-user-form-name">
            <mat-form-field id="edit-user-first-name" class="edit-user-field">
                <mat-label>First Name</mat-label>
                <span matTextPrefix> &nbsp;&nbsp;&nbsp;</span>
                <input type="text" matInput [formControl]="firstNameControl" />
            </mat-form-field>
            <mat-form-field id="edit-user-last-name" class="edit-user-field">
                <mat-label>Last Name</mat-label>
                <span matTextPrefix>&nbsp;&nbsp;&nbsp;</span>
                <input type="text" matInput [formControl]="lastNameControl" />
            </mat-form-field>
        </div>
        <mat-form-field id="edit-user-email" class="edit-user-field">
            <mat-label>Email</mat-label>
            <span matTextPrefix
                ><fa-icon [icon]="emailIcon"></fa-icon> &nbsp;&nbsp;</span
            >
            <input
                type="email"
                matInput
                placeholder="example@gmail.com"
                [formControl]="emailControl"
            />
        </mat-form-field>
        <ngx-intl-tel-input
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="true"
            [searchCountryFlag]="false"
            [selectFirstCountry]="true"
            [selectedCountryISO]="CountryISO.UnitedStates"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="true"
            [numberFormat]="PhoneNumberFormat.National"
            name="phone"
            [formControl]="phoneControl"
            [onlyCountries]="[CountryISO.UnitedStates]"
            [customPlaceholder]="'(XXX) XXX-XXXX'"
        >
        </ngx-intl-tel-input>
    </form>
    <ng-container *ngIf="displayControlErrors(editUserForm, 'firstName')">
        <mat-error *ngIf="firstNameControl.errors['required']"
            >First Name is <strong>required</strong></mat-error
        >
    </ng-container>
    <ng-container
        *ngIf="displayControlErrors(editUserForm, 'lastName', ['firstName'])"
    >
        <mat-error *ngIf="lastNameControl.errors['required']"
            >Last Name is <strong>required</strong></mat-error
        >
    </ng-container>
    <ng-container
        *ngIf="
            displayControlErrors(editUserForm, 'email', [
                'firstName',
                'lastName',
            ])
        "
    >
        <mat-error *ngIf="emailControl.errors['required']"
            >Email is <strong>required</strong></mat-error
        >
        <mat-error *ngIf="emailControl.errors['email']"
            >Please enter a valid email address</mat-error
        >
    </ng-container>
    <!--  <ng-container-->
    <!--    *ngIf="displayControlErrors(signupForm, 'phone', ['firstName','lastName','email', 'password', 'confirm'])">-->
    <!--    <mat-error *ngIf="phoneControl.errors['required']">Phone is<strong>required</strong></mat-error>-->
    <!--    <mat-error *ngIf="phoneControl.errors['pattern']">Phone is<strong> not a valid phone number</strong>-->
    <!--    </mat-error>-->
    <!--  </ng-container>-->
</mat-dialog-content>
<mat-dialog-actions>
    <div (click)="editUserForm.invalid && dirtyForm()">
        <button
            mat-flat-button
            [disabled]="editUserForm.invalid"
            (click)="editUser()"
        >
            Save Changes
        </button>
    </div>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
<!--<div id="edit-user-additional-options">-->
<!--    <div>-->
<!--        Already have an account?-->
<!--        <b class="edit-user-option" (click)="openLogin()">Login</b>-->
<!--    </div>-->
<!--    <div class="edit-user-option"><b>Forgot Password?</b></div>-->
<!--</div>-->
